import Flow from "./flow";
import { useFlow } from "./FlowProvider";
import type { CreateFlowComponent } from "./types";

const createFlowComponent: CreateFlowComponent =
  (flowType) =>
  ({ children }) => {
    const flow = useFlow();
    return flow === flowType ? children : null;
  };

export const Desktop = createFlowComponent(Flow.DESKTOP);
export const Mobile = createFlowComponent(Flow.MOBILE);
